import { Component, OnInit } from '@angular/core';
import { TopgradserviceService } from '../../../topgradservice.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-student-login',
  templateUrl: './student-login.component.html',
  styleUrls: ['./student-login.component.scss']
})
export class StudentLoginComponent implements OnInit {
  // loginform: FormGroup;
  // pass: String = 'password'
  // constructor(private Service: TopgradserviceService,
  //    private _snackBar: MatSnackBar,
  //    private _formBuilder: FormBuilder,
  //    private router: Router) {

  // }

  // ngOnInit(): void {
  //   this.loginform = this._formBuilder.group({
  //     uname: ['', [Validators.required, Validators.email]],
  //     pwd: ['', [Validators.required]]
  //   });
  // }

  // logincredentials() {
  //   var obj = {
  //     email: this.loginform.value.uname,
  //     password: this.loginform.value.pwd,
  //     type: 'student'
  //   }
  //   this.Service.login(obj).subscribe(res => {
  //     if (res?.token) {
  //       localStorage.setItem("userDetail", JSON.stringify(res.data));
  //       if (res.token) {
  //         localStorage.setItem("token", res.token);
  //         if (res?.data?.change_password) {
  //           this.router.navigate(['student/change-password']);
  //         } else {
  //           if (res.data?.student_profile) {
  //             this.router.navigate(['student/dashboard']);
  //           } else {
  //             this.router.navigate(['student/onboarding']);
  //           }
  //         }
  //         this._snackBar.open("User Logged In Successfully", "close", { duration: 2000 });
  //       }
  //     } else {
  //       this._snackBar.open(res?.message, "close", { duration: 2000 });
  //     }
      
  //   }, err => {
  //     // if (err.error.errors.msg) {
  //     //   var ErrorMsg = err.error.errors.msg
  //     // }
  //     // if (err.status >= 400) {
  //     //   this._snackBar.open(ErrorMsg, "close", {
  //     //     duration: 2000
  //     //   });
  //     // } else {
  //     //   this._snackBar.open("Some Error Occued", "close", {
  //     //     duration: 2000
  //     //   });
  //     // }

  //        // if (err.error.errors.msg) {
  //         var ErrorMsg =  err?.error?.message || err?.error?.errors?.msg || "Incorrect email or password, please try again.";
  //         // }
  //         // console.log("login error message==============>>", err.error.errors.msg)
  //         if (err.status >= 400) {
  //           this._snackBar.open(ErrorMsg, "close", {
  //             duration: 2000
  //           });
  //         }if (err?.status === 409 && err?.error?.message === "User already exists") {
  //           this._snackBar.open(ErrorMsg, "close", { duration: 2000 });
  //         } else {
  //           this._snackBar.open(ErrorMsg, "close", {
  //             duration: 2000
  //           });
  //         }
  //   })
  // }


  // onEyeClick(field: any, type: any) {
  //   if (field == 'pass') {
  //     this.pass = type
  //   }
  // }

  // forgotPassword() {
  //   this.router.navigate(['/forgetPassword'], {queryParams: {type: 'student'}});
  // }

  loginform: FormGroup;
  isEmail:boolean = false;
  pass: String = 'password'
  constructor(private Service: TopgradserviceService,
     private _snackBar: MatSnackBar,
     private _formBuilder: FormBuilder,
     private router: Router) {

  }

  ngOnInit(): void {
    history.pushState(null, '', location.href);
    
    window.addEventListener('popstate', (event) => {
      if (this.isEmail) {
        this.isEmail = false;
        history.pushState(null, '', location.href); // Prevent back navigation
        return false;
      } else {
        // alert('Back button is disabled!');
        history.pushState(null, '', location.href);
      }
    });
    this.loginform = this._formBuilder.group({
      uname: ['', [Validators.required, Validators.email]],
      pwd: ['', [Validators.required]]
    });
  }

  logincredentials() {
    var obj = {
      email: this.loginform.value.uname,
      password: this.loginform.value.pwd,
      type: 'student'
    }
    this.Service.login(obj).subscribe(res => {
      if (res?.token) {
        localStorage.setItem("userDetail", JSON.stringify(res.data));
        if (res.token) {
          localStorage.setItem("token", res.token);
          if (res?.data?.change_password) {
            this.router.navigate(['student/change-password']);
          } else {
            if (res.data?.student_profile) {
              this.router.navigate(['student/dashboard']);
            } else {
              this.router.navigate(['student/onboarding']);
            }
          }
          this._snackBar.open("User Logged In Successfully", "close", { duration: 2000 });
        }
      } else {
        this._snackBar.open(res?.message, "close", { duration: 2000 });
      }
      
    }, err => {
      console.log("login error==============>>", err)
      // if (err.error.errors.msg) {
      //   var ErrorMsg = err.error.errors.msg
      // }
      // console.log("login error message==============>>", err.error.errors.msg)
      // if (err.status >= 400) {
      //   this._snackBar.open(ErrorMsg, "close", {
      //     duration: 2000
      //   });
      // } else {
      //   this._snackBar.open("Some Error Occued", "close", {
      //     duration: 2000
      //   });
      // }
      var ErrorMsg =  err?.error?.message || err?.error?.errors?.msg || "Incorrect email or password, please try again.";
      if (err.status >= 400) {
        this._snackBar.open(ErrorMsg, "close", {
          duration: 2000
        });
      }if (err?.status === 409 && err?.error?.message === "User already exists") {
        this._snackBar.open(ErrorMsg, "close", { duration: 2000 });
      } else {
        this._snackBar.open(ErrorMsg, "close", {
          duration: 2000
        });
      }

    })
  }


  userDetails:any = {};

  getEmailDetail(){
    // this.isEmail = true;
    var obj = {
      email: this.loginform.value.uname,
      type: 'student'  //admin,student,employee
    }
    this.Service.getUserByEmail(obj).subscribe(res => {
      if(res.code == 200){
        this.userDetails = res.data;
        this.isEmail = true;
      }else{
        this._snackBar.open(res.message, "close", { duration: 2000 });
      }
    }, err => {
      if (err.error.errors.msg) {
        var ErrorMsg = err.error.errors.msg
      }
      if (err.status >= 400) {
        this._snackBar.open(ErrorMsg, "close", {
          duration: 2000
        });
      } else {
        this._snackBar.open("Some Error Occued", "close", {
          duration: 2000
        });
      }

    })
  }

  onEyeClick(field: any, type: any) {
    console.log(field)
    if (field == 'pass') {
      this.pass = type
    }
  }

  forgotPassword() {
    this.router.navigate(['/forgetPassword'], {queryParams: {type: 'student'}});
  }
}
